import { useAmenitiesIcons } from 'frontend/components/hooks/packages';
import commons from '../../../commons/commons';
import { targetFromUrl } from '../../../utils/url';
import './banner.css';

export default function Banner({ data, className }) {
  const [getIcon] = useAmenitiesIcons();
  const {
    title,
    description,
    price,
    manualPrice,
    services,
    id,
    mostrarTitulo,
    mostrarDescripcion,
    mostrarPrecio,
    mostrarDescuento,
    mostrarExtra,
  } = data;
  const biyu = price === null ? manualPrice : price;
  const imgUrlValidated = commons.imgUrlValidator(data.imageUrl);
  const url = commons.addBasePath(process.env.RAZZLE_PACKAGES_BASE_PATH, data.url);

  const renderAmenitiesIcons =
    services &&
    services.map((serviceKeyName) => (
      <span key={`${title}-service-${serviceKeyName}`} className="mr-2">
        <i className={getIcon(serviceKeyName)} />
      </span>
    ));

  return (
    <div id={data.id} className={`${className ?? ''} banner-container no-video`}>
      <a
        href={data.esConsulta ? `/consulta/${id}` : data.detalle ? `/consultaDetalle/${id}` : url}
        target={url && targetFromUrl(url)}
        rel="noreferrer"
      >
        <div className="banner_img-container relative">
          <div className="banner_tag-amenities">
            {data.tag && !mostrarExtra && <div className="banner_tag">{data.tag}</div>}
            {!mostrarPrecio && data.manualPrice && (
              <div className="banner_tag_price">{data.manualPrice}</div>
            )}
            {!mostrarDescuento && data.descuento && (
              <div className="banner_tag_price">{data.descuento}</div>
            )}
            {services && services.length > 0 && (
              <div className="banner_amenities py-2 px-4 last:mr-0">{renderAmenitiesIcons}</div>
            )}
          </div>
          <img className="banner_img shadow-sm rounded-sm" src={imgUrlValidated} alt="title" />
        </div>
        <div className="flex justify-between items-center p-3">
          <div className="text-information">
            {!mostrarTitulo && title && <div className="banner_info-title">{title}</div>}
            {!mostrarDescripcion && description && (
              <div className="banner_info-description ">
                {description[0].toUpperCase() + description.slice(1)}
              </div>
            )}
          </div>
          {biyu && <div className="banner_price-information  text-xl font-medium">{biyu}</div>}
        </div>
      </a>
    </div>
  );
}
